import PropTypes from 'prop-types'

import { FormControl } from 'baseui/form-control'
import { SIZE } from 'baseui/input'

import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { useTranslation } from 'react-i18next'
import { formControlOverrides } from '@/shared/components/SDComponentsNewDesign/styled-components'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'
import SDMaskedInput from '@/shared/components/SDComponentsNewDesign/SDMaskedInput/SDMaskedInput'

const ProSiret = ({
  currentValue,
  error,
  onChangeHandler,
  removeErrors,
  disabled,
  forceValidation = true,
  hidden = false,
  validationHandler,
  isLoading,
  status,
}) => {
  const { t } = useTranslation()
  let finalStatus = ''
  if (status === false && error !== '') {
    finalStatus = 'error'
  }
  if (status === true && currentValue?.length > 0) {
    finalStatus = 'valid'
  }
  if (hidden) {
    return null
  }
  return (
    <>
      <FormControl error={error} overrides={formControlOverrides}>
        <SDMaskedInput
          label={mandatoryTag + t('subscriptionForm:customer_module.proSiret.label')}
          disabled={disabled}
          size={SIZE.compact}
          mask='999 999 999 99999'
          currentValue={currentValue}
          onBlur={siretValue => {
            removeErrors('pro_siret')
            onChangeHandler(siretValue.replace(/\s/g, ''))
          }}
          status={finalStatus}
        />
      </FormControl>

      {error !== '' && forceValidation && (
        <FormControl label={t('subscriptionForm:customer_module.proSiret.force_label')}>
          <SDButton
            block={true}
            onClick={event => {
              event.preventDefault()
              removeErrors('pro_siret')
            }}
          >
            {t('subscriptionForm:customer_module.proSiret.force')}
          </SDButton>
        </FormControl>
      )}

      {disabled === false && (
        <FormControl>
          <SDButton isLoading={isLoading} block={true} onClick={validationHandler}>
            {t('subscriptionForm:customer_module.proSiret.validate')}
          </SDButton>
        </FormControl>
      )}
    </>
  )
}

ProSiret.propTypes = {
  currentValue: PropTypes.string,
  error: PropTypes.string,
  onChangeHandler: PropTypes.func,
  removeErrors: PropTypes.func,
  validationHandler: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  forceValidation: PropTypes.bool,
  hidden: PropTypes.bool,
  status: PropTypes.bool,
}

export default ProSiret
